import React from "react";
import Slider from "react-slick";
import emptyImage from "assets/images/imgs/emptyImg.png";
import "./thumbnailCarousel.scss";

const ThumbnailCarousel = ({ images = [], height = 390, className = "" }) => {
    const settings = {
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    return (
        <div className={`thumbnail-carousel ${className}`}>
            <Slider {...settings} style={{ height: `${height}px` }}>
                {images.length > 0 ? (
                    images.map((image, index) => (
                        <div
                            key={`thumbnail-${index}`}
                            className="carousel-slide"
                            style={{ width: `auto` }}
                        >
                            <img
                                src={image}
                                alt={`thumbnail-${index + 1}`}
                                className="carousel-image"
                                tabIndex={0}
                                aria-label={`이미지 ${index + 1}`}
                                onError={(e) => {
                                    e.currentTarget.src = emptyImage;
                                }}
                            />
                        </div>
                    ))
                ) : (
                    <div className="carousel-slide">
                        <img
                            src={emptyImage}
                            alt="기본 이미지"
                            className="carousel-image"
                        />
                    </div>
                )}
            </Slider>
        </div>
    );
};

export default ThumbnailCarousel;
